import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSideNavigation } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './MonthlyCasePage.module.css';

export const MonthlyCasePageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const title = intl.formatMessage({ id: 'MonthlyCasePage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="MonthlyCasePage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              isWhiteBgNav={false}
              isHeaderSticky={true}
            />
          </>
        }
        hideCssMainClass
        sideNav={null}
        currentPage="MonthlyCasePage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <h1>Rewards Program</h1>
          <p>There is no active Stay Greedless rewards promotion at this time.</p>
          <p>
            Any future promotion will be announced with separate Official Rules describing
            eligibility, entry methods, geographic restrictions, prizes, selection procedures, and
            all other material terms. Future promotions will be void where prohibited or restricted
            by law.
          </p>
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

MonthlyCasePageComponent.defaultProps = {};

MonthlyCasePageComponent.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const MonthlyCasePage = compose(
  connect(mapStateToProps, null),
  injectIntl
)(MonthlyCasePageComponent);

export default MonthlyCasePage;
